import { exportSave, normaliseEnvelope, type SaveStorage } from '../sim/index';
import type { PlayerProfile } from './schema';

function bodyOf(text: string): string | null {
  const first = text.indexOf('.');
  const second = first < 0 ? -1 : text.indexOf('.', first + 1);
  return first < 0 || second < 0 ? null : text.slice(second + 1);
}

/** Re-export one canonical envelope after changing only its product profile. */
export function withPlayerProfile(text: string, profile: PlayerProfile): string {
  const body = bodyOf(text);
  if (body === null) return text;
  try {
    const parsed: unknown = JSON.parse(body);
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) return text;
    return exportSave(normaliseEnvelope({ ...(parsed as Record<string, unknown>), profile }));
  } catch {
    return text;
  }
}

/** Decorates the one live-save port; it intentionally owns no extra storage key. */
export function profileStorage(inner: SaveStorage, current: () => PlayerProfile | null): SaveStorage {
  return {
    read: key => inner.read(key),
    write: (key, value) => {
      const profile = current();
      inner.write(key, profile === null ? value : withPlayerProfile(value, profile));
    },
    remove: key => inner.remove(key),
  };
}
